import { forwardRef } from 'react';

function joinClasses(...parts) {
  return parts.filter(Boolean).join(' ');
}

/**
 * Canonical Prii text input — glass fill, shared height, focus ring, placeholder styling.
 * Use for all single-line fields (forms, compose, confirmation, etc.).
 */
const TextInput = forwardRef(function TextInput(
  { className = '', invalid = false, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={joinClasses('text-input', invalid && 'text-input--invalid', className)}
      {...props}
    />
  );
});

export default TextInput;
